// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setSelectedFolderableOperation = createAction('[Folders] Set Selected Folderable Operation', props());
